"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var html_to_msgid_1 = __importDefault(require("./html_to_msgid"));
var translate_1 = __importDefault(require("./translate"));
function directive(htmlToMsgId, translate) {
    return {
        bind: function (el, _a) {
            var value = _a.value;
            el.dataset.msgid = htmlToMsgId(el.innerHTML);
            var context = el.getAttribute('context');
            el.innerHTML = translate(el.dataset.msgid, value, context);
        },
        update: function (el, _a) {
            var value = _a.value;
            var context = el.getAttribute('context');
            el.innerHTML = translate(el.dataset.msgid, value, context);
        },
    };
}
exports.directive = directive;
exports.default = directive(html_to_msgid_1.default, translate_1.default);
//# sourceMappingURL=directive.js.map